import Vue from 'vue';

export interface ILink {
  name: string;
  leaves?: boolean;
  modules?: string[];
  lockModule?: string;
  icon?: string;
  show: boolean;
  unlock: boolean;
  subMenu?: ILink[];

  [key: string]: any;
}

export let Links: ILink[] = Vue.observable([
    {
      name: 'TPV',
      leaves: false,
      icon: 'monitor',
      show: false,
      unlock: false,
      link: '/requests',
      modules: ['orders'],
    },
    {
      name: 'card',
      icon: 'restaurant',
      modules: ['products'],
      leaves: true,
      openTab: false,
      subMenu: [
        {
          name: 'categories',
          link: '/categories/list',
          modules: ['categories'],
          icon: 'category',
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'products',
          link: '/products/list',
          modules: ['products'],
          icon: 'fastfood',
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'modifiers',
          link: '/modifiers/list',
          modules: ['products'],
          icon: 'edit_note',
          leaves: false,
          show: true,
          unlock: false,
        },
      ],
      show: false,
      unlock: false,
    },
    {
      name: 'distribution',
      icon: 'table_bar',
      modules: ['tables'],
      leaves: true,
      openTab: false,
      subMenu: [
        {
          name: 'tableMap',
          link: '/distribution',
          icon: 'table_bar',
          modules: ['tables', 'zones'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'screens',
          link: '/screens/list',
          icon: 'monitor',
          modules: ['screens'],
          leaves: false,
          show: false,
          unlock: false,
        },
      ],
      show: false,
      unlock: false,
    },
    {
      name: 'loyalty',
      icon: 'mdi-gift',
      modules: ['loyalty'],
      leaves: true,
      openTab: false,
      subMenu: [
        {
          name: 'awards',
          link: '/awards/list',
          icon: 'stars',
          modules: ['awards'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'offers',
          link: '/offers/list',
          icon: 'mdi-offer',
          modules: ['offers'],
          leaves: false,
          show: false,
          unlock: false,
        },
      ],
      show: false,
      unlock: false,
    },
    {
      name: 'employees',
      link: '/employees/list',
      icon: 'engineering',
      modules: ['auth_system'],
      leaves: false,
      show: false,
      unlock: false,
    },
    // {
    //   name: 'Roles',
    //   link: '/roles/list',
    //   icon: 'people',
    //   modules: 'auth_system',
    //   leaves: false,
    //   show: false,
    // },
    {
      name: 'clients',
      link: '/clients/list',
      icon: 'person',
      modules: ['clients'],
      leaves: false,
      show: false,
      unlock: false,
    },
    {
      name: 'printers',
      icon: 'print',
      modules: ['printers'],
      leaves: true,
      openTab: false,
      subMenu: [
        {
          name: 'printers',
          link: '/printers/list',
          icon: 'print',
          modules: ['printers'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'families',
          link: '/categories_families/list',
          icon: 'group_work',
          modules: ['families'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'cashiers',
          link: '/cashiers/list',
          icon: 'money',
          modules: ['cashiers'],
          leaves: false,
          show: true,
          unlock: true,
        },
      ],
      show: false,
      unlock: false,
    },
    {
      name: 'cashRegister',
      link: '/printers/box_report',
      icon: 'point_of_sale',
      modules: ['printers'],
      leaves: false,
      show: false,
      unlock: false,
    },
    {
      name: 'bookings',
      icon: 'date_range',
      modules: ['reservations'],
      lockModule: 'reservas',
      link: '/bookings',
      leaves: true,
      openTab: false,
      subMenu: [
        {
          name: 'bookings',
          link: '/bookings',
          icon: 'event',
          modules: ['reservations'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'shifts',
          link: '/shifts/list',
          icon: 'date_range',
          modules: ['shifts'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'booking-options',
          link: '/bookings_options',
          icon: 'list',
          modules: ['reservations'],
          leaves: false,
          show: false,
          unlock: false,
        },
      ],
      show: false,
      unlock: false,
    },
    {
      name: 'reports',
      icon: 'assignment',
      modules: ['reports'],
      link: '/reports',
      leaves: false,
      show: true,
      unlock: true,
    },
    {
      name: 'settings',
      link: '/settings',
      icon: 'settings',
      modules: ['settings'],
      leaves: false,
      show: false,
      unlock: false,
    },
    {
      name: 'stock',
      icon: 'warehouse',
      modules: ['stk'],
      lockModule: 'stock',
      link: '/stock',
      leaves: false,
      show: false,
      unlock: false,
      /*openTab: false,
      subMenu: [
        {
          name: 'stockReport',
          link: '/stocks/stock_report',
          icon: 'warehouse',
          modules: ['stk'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'recipes',
          link: '/recipes/list',
          icon: 'mdi-nutrition',
          modules: ['stk'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'purchases',
          link: '/purchases/add',
          icon: 'add_shopping_cart',
          modules: ['stk'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'purchaseOrders',
          link: '/purchase_orders/list',
          icon: 'mdi-cart-arrow-up',
          module: 'stk',
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'stocks',
          link: '/stocks/list',
          icon: 'inventory_2',
          modules: ['stk'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'provider',
          link: '/providers/list',
          icon: 'person',
          modules: ['stk'],
          leaves: false,
          show: false,
          unlock: false,
        },
        {
          name: 'ingredients',
          link: '/ingredients/list',
          modules: ['ingredients'],
          icon: 'hub',
          leaves: false,
          show: false,
          unlock: false,
        },
      ],*/
    },
  ])
;
